import type { SectionsDividerComponent } from '@twisto/api-cms'

import * as styles from './divider.styles'

export const Divider = ({ variant, background }: SectionsDividerComponent) => (
  <div
    css={[
      styles.divider(background),
      variant === 'default' ? styles.defaultVariant : styles.additionalVariant,
    ]}
  />
)
